import * as React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';

export default function TabsMui({tabs, children}) {
  const [value, setValue] = React.useState(tabs?.[0]?.value || '1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const childrenWithValue = React.Children.map(children, child =>
    React.isValidElement(child) && child.props.value === value ? child : null
  );

  return (
    <Box sx={{ width: '100%', typography: 'body1' }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChange} aria-label="lab API tabs">
            {tabs.map((tab) => (
              <Tab key={tab.value} label={tab.label} value={tab.value} />
            ))}
          </TabList>
        </Box>
        {childrenWithValue}
      </TabContext>
    </Box>
  );
}
